<template>
  <div>
    <CCardBody>
      <div class="d-flex justify-content-end align-items-center ">
        <button type="button" class="btn addBtn" @click="showCreateModal">Create</button>
      </div>
      <div class="d-flex justify-content-end align-items-center ">
        <search-items v-model="search" :searchHandler="searchCustomer" :placeholder="'Type to search'"></search-items>
      </div>
      <b-table
          :items="customers"
          :fields="headers"
          hover
          sorter
      >
        <template #cell(image_url)="item">
          <img class="cat_image" :src="base_url+'/'+item.item.image_url">
        </template>
        <template #cell(actions)="item">
          <edit class="delete_step ml-2" @click="editCustomer(item.item)" fillColor="#009FE3" />
          <delete class="delete_step ml-2" @click="deleteCustomer(item.item.id)" fillColor="#E30000" />
          <Key   @click="loginUser(item.item.id)" fillColor="#E1A144" title="login as user" :id="item.id" />
        </template>
      </b-table>

      <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.rows"
          :per-page="pagination.perPage"
          aria-controls="itemList"
          align="center"
          @change="handlePagination"
          v-if="pagination.total > 0"
      ></b-pagination>

      <b-modal id="editCustomer" size="lg" no-close-on-backdrop  hide-footer>
        <template #modal-title>
          <span>{{ formStatus }}</span>
        </template>
        <div class="row">
          <div class="col-sm-6">
            <label for="" class="required">First Name</label>
            <b-form-group>
              <b-form-input class="form-input"  type="text" 
                            v-model="first_name">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <label for="" class="required">Last Name</label>
            <b-form-group>
              <b-form-input class="form-input"  type="text" 
                            v-model="last_name"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-6">
            <label for="" class="required">Password</label>
            <b-form-group>
              <b-form-input class="form-input"  type="password" name="permission"
                            v-model="password"></b-form-input>
            </b-form-group>

          </div>
          <div class="col-sm-6">
            <label for="" class="required">Confirm Password</label>
            <b-form-group>
              <b-form-input class="form-input"  type="password" name="password_confirmation"
                            v-model="password_confirmation"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row  mt-3">
          <div class="col-sm-6">
            <label for="" class="required">Email</label>
            <b-form-group>
            <b-form-input class="form-input"  type="text" name="email"
                          v-model="email"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <label class="required" >Role</label>
            <b-form-group>
              <b-form-select class="mt-3" name="role_id" label-field="name"  v-model="role_id" :options="customerRoleOptions"></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div class="row  mt-3">
          <div class="col-sm-6">
            <!-- <label for="" class="required">Email</label> -->
            <b-form-group>
            <b-form-checkbox switch v-model="is_notifications_enabled" name="is_notifications_enabled" aria-label="Enable notifications">
              Enable Email Communication {{ is_notifications_enabled}}
            </b-form-checkbox>
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-6">
            <b-form-group>
              <b-button size="md"  class="btn btn-secondary" @click="updateCustomer"> Update </b-button>
            </b-form-group>
          </div>
        </div>
      </b-modal>

      <b-modal id="createCustomer" size="lg" no-close-on-backdrop  hide-footer>
        <template #modal-title>
          <span>Create Customer</span>
        </template>
        <p class="bg-info p-2 text-gray-300" v-show="showAlert">
          <Info :class="'mr-1'"/>Please note: Customers created here are for manual order processing only and won’t have login access to your site.
        </p>
        <div class="row">
          <div class="col-sm-6">
            <label for="">First Name</label>
            <b-form-group>
              <b-form-input class="form-input" name="first_name" type="text"
                            v-model="first_name">
                          </b-form-input>
                  <span class="text-danger" v-if="errors.has('first_name')">{{ errors.first('first_name') }}</span>                      
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <label for="">Last Name</label>
            <b-form-group>
              <b-form-input class="form-input" name="last_name" type="text"
                            v-model="last_name"></b-form-input>
                  <span class="text-danger" v-if="errors.has('last_name')">{{ errors.first('last_name') }}</span>           
            </b-form-group>
          </div>
        </div>
        <div class="row mt-3"  v-if="!isEcommercePlatform()">
          <div class="col-sm-6" vid="password">
            <label for="">Password</label>
            <b-form-group>
              <b-form-input class="form-input"  type="password" name="password" v-validate="'min:6'"
                            v-model="password"></b-form-input>
                  <span class="text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</span>           
            </b-form-group>

          </div>
          <div class="col-sm-6" vid="password_confirmation">
            <label for="">Confirm Password</label>
            <b-form-group>
              <b-form-input class="form-input"  type="password" name="password_confirmation" :v-validate="'required|confirmed:password'"
                            v-model="password_confirmation"></b-form-input>
                  <span class="text-danger" v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>           
            </b-form-group>
          </div>
        </div>
        <div class="row  mt-3">
          <div class="col-sm-6">
            <label for="" class="required">Email</label>
            <b-form-group>
            <b-form-input class="form-input"  type="text" name="email"
                          v-model="email" v-validate="'required|email'"></b-form-input>
              <span class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</span>

            </b-form-group>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-6">
            <b-form-group>
              <b-button size="md"  class="btn btn-secondary" @click="createCustomer"> Create </b-button>
            </b-form-group>
          </div>
        </div>
      </b-modal>
    </CCardBody>
  </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete.vue';
import Key from 'vue-material-design-icons/Key.vue';
import Info from 'vue-material-design-icons/Information.vue';
import Edit from 'vue-material-design-icons/Pencil.vue';
import {http} from "@/config/httpCommon";
import {getPageModal, isEcommercePlatform, removePageModal, setPageModal} from "@/helpers/Helpers";
import SearchItems from '@/components/SearchItems.vue';
import { Validator } from 'vee-validate'

export default {
  components:{
    Delete,
    Edit,
    Key,
    SearchItems,
    Info
  },
  data () {
    return {
      search:'',
      formStatus:'Update Customer',
      stepModal: false,
      customer_id: 0,
      first_name: '',
      last_name: '',
      email:'',
      password:'',
      role_id:null,
      password_confirmation:'',
      is_notifications_enabled:true,
      headers: [
        {key: 'first_name', label: 'First Name',},
        {key: 'last_name', label: 'Last Name'},
        {key: 'email', label: 'Email'},
        {key: 'is_notifications_enable', label:'Notifications'},
        {key: 'team_company_name', label:'Team / Company Name'},
        {key: 'country_name', label:'Country'},
        {key: 'store', label: 'Associated Merchant'},
        {key: 'actions', label: 'Actions',},
      ],
      customers: [],
      base_url: process.env.VUE_APP_FILE_URL,
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      customerRoleOptions:[],
      customerTypeOptions: [],
      showAlert: false
    }
  },
  async mounted() {
    let company = this.$store.getters.company;
    const get_roles = await http.get(`role?type=customizer`)
    let roles = get_roles.data.result.roles;
    if(company && company.platform == 'cdnExceptLogin') {
      this.showAlert = true;
    }
    this.customerRoleOptions.push({
      text:'No role', value:null
    })
    for (let index = 0; index < roles.length; index++) {
      let item = roles[index];
      if(item.name == 'collectionManager') {
        if(company.platform == 'shopify') {
          this.customerRoleOptions.push({
            text:item.name, value:item.id
          })
        }

      } else {
        this.customerRoleOptions.push({
          text:item.name, value:item.id
        })
      }

    }
    Validator.extend('no_numbers', {
      getMessage: field => `${field} must not contain numbers.`,
      validate: value => /^[^\d]*$/.test(value) // no digits allowed
    })
  },
  async created(){
    this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getCustomers)
  },
  methods: {
    isEcommercePlatform,
    searchCustomer(){
      let params = ''
      if(this.search) {
        this.search = encodeURIComponent(this.search)
        params = '?search='+this.search
      }
      setPageModal(1,this.$route.name,this.search);
      this.getCustomers(params);
    },
    async getCustomers(params) {
      let res = await this.$store.dispatch("getCustomers", params);
      this.customers = this.$store.getters.getCustomers;
      this.makePagination(res.data);
    },
    async handlePagination(page=''){
      let params = '?page='+page;
      if(this.search) {
        params += '&search='+this.search
      }
      setPageModal(page,this.$route.name,this.search);
      this.getCustomers(params);
    },
    makePagination(data){
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.rows = data.meta.total;
      this.pagination.perPage = data.meta.per_page;
      this.pagination.total = data.meta.total;
    },
    editCustomer(item){
      console.log("item", item)
      this.customer_id = item.id;
      this.first_name = item.first_name;
      this.last_name = item.last_name;
      this.email = item.email
      this.role_id = item.role_id
      this.is_notifications_enabled = Boolean(item.is_notifications_enabled)
      this.$bvModal.show("editCustomer");
    },
    showModal(){
      this.$bvModal.show("customerModal");
    },
    showCreateModal() {
      this.$bvModal.show('createCustomer')
    },
    async createCustomer(){
      let valid = await this.$validator.validate()
      if(valid) {
        try {
          let payload = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
          }
          
          await this.$store.dispatch('createCustomer', payload)
          this.clearForm()
          this.customers = this.$store.getters.getCustomers
          this.preservePagination('page', 'search', this.$route.name, this.getCustomers)
          this.$bvModal.hide("createCustomer");
          this.showToast('Customer created successfully', 'SUCCESS');
        } catch(err) {
          this.showError(err)
          console.log(err)
        }
      }
    },
    async updateCustomer(){
      let valid = await this.$validator.validate();
      if(valid){
        try{
          let payload = {
            id: this.customer_id,
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
            role_id: this.role_id,
            is_notifications_enabled: this.is_notifications_enabled ? 1 : 0,
          }

          await this.$store.dispatch("updateCustomer", payload);
          this.clearForm()
          this.customers = this.$store.getters.getCustomers;
          this.preservePagination( 'page', 'search', this.$route.name, this.getCustomers);
          //console.log(this.customers)
          this.$bvModal.hide("editCustomer");
          this.showToast('Customer updated successfully', 'SUCCESS');
        }catch(err){
          this.showError(err);
          console.log("err", err);
        }
      }
    },
    async deleteCustomer(id){
      this.$fire({
        title: "Are you sure!",
        text: "The selected user will be deleted",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async action => {
        if(action.value) {
          try{
            await this.$store.dispatch("deleteCustomer", id);
            this.customers = this.$store.getters.getCustomers;
            this.previousPageOnDeletion('page','search',this.customers.length,this.$route.name,this.getCustomers);
            this.showToast('Customer deleted successfully', 'SUCCESS');
          }catch(err){
            this.showError(err);
            console.log("Errror", err)
          }
        }
      });
    },
    async updateTable(){
      try{
        this.$store.commit('set', ['showLoader', true]);
        await this.$store.dispatch('getCustomers', '?search='+this.search);
        this.categories = this.$store.getters.getCategories;
        this.pages = this.$store.getters.totalPages;
        this.current_page = 1;
        this.$store.commit('set', ['showLoader', false]);
      }catch(err){
        this.$store.commit('set', ['showLoader', false]);
        console.log(err)
      }
    },
    async myFunction(currentPage){
      try{
        this.current_page=currentPage;
        let params = '?name='+this.search+'&page='+currentPage;
        this.$store.commit('set', ['showLoader', true]);
        await this.$store.dispatch('getCategories', params);
        this.$store.commit('set', ['showLoader', false]);
        this.categories = this.$store.getters.getCategories;
        this.pages = this.$store.getters.totalPages;
      }catch(err){
        this.$store.commit('set', ['showLoader', false]);
        console.log("Error: ", err.response.data.errors);
      }
    },
    clearForm(){
      this.customer_id = 0
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.password = ''
      this.password_confirmation = ''
      this.is_notifications_enabled = false
    },
    loginUser(id){
      http.get(`customer/information/${id}`).then((res) =>{
        let token = res.data.access_token
        if (res.data.user.company_url){
          const url = res.data.user.company_url+'/#/'
          window.open(`${url}admin/login?token=${token}`);
        }
      }).catch(err =>{
        console.log(err)
      })
    }
  },
}
</script>
<style type="scss">
.delete_step{
  cursor: pointer;
}
.cat_image{
  width: 100%;
  max-width: 20px;
}
</style>